function initAccordions() {
  const accordions = document.querySelectorAll<HTMLElement>("[data-accordion]");
  const currentLang = document.documentElement.lang;

  if (accordions.length < 1) return;

  accordions.forEach((accordion) => {
    const accordionId = accordion.getAttribute("id");
    const toggle = accordion.querySelector(
      `button[aria-controls="accordion-${accordionId}"]`
    ) as HTMLButtonElement;
    const accordionBody = accordion.querySelector(
      `[data-accordion-body="${accordionId}"]`
    ) as HTMLElement;

    if (toggle && accordionBody) {
      toggle.addEventListener("click", handleAccordionClick);
      accordionBody.addEventListener("transitionend", handleTransitionEnd);
    }

    // Update toggle text for french
    if (currentLang === "fr") {
      const isOpen = accordion.hasAttribute("data-accordion-open");
      if (isOpen) {
        toggle.setAttribute("data-accordion-toggle", "Lire moins");
      } else {
        toggle.setAttribute("data-accordion-toggle", "Lire la suite");
      }
    }

    // assign parent's id to child accordions
    if (accordion.querySelectorAll("[data-accordion]").length > 0) {
      const childAccordions = accordion.querySelectorAll("[data-accordion]");
      childAccordions.forEach((childAccordion) => {
        childAccordion.setAttribute("data-parent", accordionId as string);
      });
    }

    // open accordion if hash matches
    if (window.location.hash) {
      const hash = window.location.hash.replace("#", "");
      const accordionId = accordion.getAttribute("id");
      if (accordionId === hash) {
        toggle.click();

        const parentAccordionId = accordion.getAttribute("data-parent");
        if (parentAccordionId) {
          const parentAccordion = document.getElementById(parentAccordionId);
          const parentToggle = parentAccordion?.querySelector(
            `button[aria-controls="accordion-${parentAccordionId}"]`
          ) as HTMLButtonElement;
          parentToggle?.click();
        }
      }
    }
  });
}

// only add the hidden attribute to the accordion body content after accordion has transitioned
function handleTransitionEnd(event: TransitionEvent) {
  const targetId = (event.target as HTMLElement)?.getAttribute("data-accordion-body");
  const accordion = document.getElementById(targetId as string);
  const accordionBodyContent = accordion?.querySelector(`#accordion-${targetId}`);
  const accordionIsClosing = !accordion?.hasAttribute("data-accordion-open");

  if (accordionBodyContent && accordionIsClosing) {
    accordionBodyContent.setAttribute("hidden", "");
  } else {
    const rect = accordion?.getBoundingClientRect() as DOMRect;
    const scrollContainer = accordion?.closest(".nav-item-dropdown") as HTMLElement;

    if (!scrollContainer || !rect) return;

    const containerRect = scrollContainer.getBoundingClientRect();
    const offset = 100;

    scrollContainer.scrollTo({
      top: scrollContainer.scrollTop + (rect.top - containerRect.top - offset),
      behavior: "smooth",
    });
  }
}

function handleAccordionClick(event: MouseEvent | TouchEvent) {
  const currentLang = document.documentElement.lang;
  const target = event.target as HTMLElement;
  const button = target.closest("button");

  if (!button) return;

  const targetId = button.getAttribute("aria-controls")?.replace("accordion-", "");
  const accordion = document.getElementById(targetId as string);
  const accordionId = accordion?.getAttribute("id");
  const toggle = accordion?.querySelector(
    `button[aria-controls="accordion-${accordionId}"]`
  ) as HTMLButtonElement;
  const accordionIsOpen = toggle?.getAttribute("aria-expanded") === "true";
  const accordionBodyContent = accordion?.querySelector(`#accordion-${accordionId}`);

  if (!accordion) return;

  // Only one open per group
  const group = accordion.getAttribute("data-accordion-group");
  if (group) {
    const groupAccordions = document.querySelectorAll(`[data-accordion-group="${group}"]`);
    const currentAccordion = Array.from(groupAccordions).find((acc) =>
      acc.hasAttribute("data-accordion-open")
    );

    if (currentAccordion) {
      const currentToggle = currentAccordion.querySelector(
        `button[aria-controls="accordion-${currentAccordion.getAttribute("id")}"]`
      ) as HTMLButtonElement;

      if (currentToggle) currentToggle.click();
    }
  }

  if (accordionIsOpen) {
    accordion.removeAttribute("data-accordion-open");
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute(
      "data-accordion-toggle",
      currentLang === "en" ? "Read more" : "Lire la suite"
    );
  } else {
    accordionBodyContent?.removeAttribute("hidden");
    accordion.setAttribute("data-accordion-open", "");
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("data-accordion-toggle", currentLang === "en" ? "Read less" : "Lire moins");
  }
}

initAccordions();
